import type { ReactNode } from 'react'
import { useI18n } from '../i18n/useI18n'

export function Loading() {
  const { t } = useI18n()
  return <p className="muted">{t('loading')}</p>
}

/**
 * Echec de lecture. Toujours accompagne d'un bouton pour reessayer :
 * sur une connexion irreguliere, une requete perdue est le cas normal,
 * pas une exception.
 */
export function ErrorState({
  message,
  onRetry,
}: {
  message?: string | null
  onRetry: () => void
}) {
  const { t } = useI18n()
  return (
    <div className="card">
      <p className="alert alert--error">{t('error_load')}</p>
      {message && (
        <details className="alert__detail">
          <summary>{t('login_error_detail')}</summary>
          <code>{message}</code>
        </details>
      )}
      <button type="button" className="btn btn--ghost" onClick={onRetry}>
        {t('retry')}
      </button>
    </div>
  )
}

export function EmptyState({
  title,
  body,
  action,
}: {
  title: string
  body?: string
  action?: ReactNode
}) {
  return (
    <div className="card">
      <h2>{title}</h2>
      {body && <p className="muted">{body}</p>}
      {action}
    </div>
  )
}

/** Banniere d'avertissement, pour les baux expires notamment. */
export function Banner({
  tone = 'warn',
  children,
}: {
  tone?: 'warn' | 'error'
  children: ReactNode
}) {
  return <div className={`banner banner--${tone}`}>{children}</div>
}
